import { FilterType, type FilterTypesMap, type GenericFiltersMap, type RangeFilterValues } from "./filterUtils";
import dateTimeUtils from "./dateTimeUtils";
import ObjectUtils from "./objectUtils";

export const formatFilters = <T extends string | number>(
  filters: GenericFiltersMap<T>,
  filterOptions: FilterTypesMap<T>,
): GenericFiltersMap<string> => {
  let queryParams = {} as GenericFiltersMap<string>;

  ObjectUtils.typedEntries<T, unknown>(filters).forEach(([key, value]) => {
    switch (filterOptions[key]) {
      case FilterType.DateRange: {
        const dateRange = value as RangeFilterValues;
        if (dateRange.from) {
          queryParams[`${String(key)}From`] = dateTimeUtils.formatDateForServer(dateRange.from, "from");
        }
        if (dateRange.to) {
          queryParams[`${String(key)}To`] = dateTimeUtils.formatDateForServer(dateRange.to, "to");
        }
        break;
      }
      case FilterType.Array:
      case FilterType.Value:
      default:
        queryParams[String(key)] = value;
    }
  });

  return queryParams;
};
